import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateInviteStudentStatus = createAsyncThunk('updateInviteStudentStatus', async (data) => {

    try {
        const token = SessionManager.getCookie("user_token")
        const headers = { "Content-Type": "application/json" }
        if (token) {
            headers.Authorization = token
        }
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + `update_invite_student_status`,
            data: data?.values,
            headers
        })
        return res
    } catch (error) {
        return error.response
    }
})
